module.exports = __webpack_public_path__ + "img/landing3bw.61b5bca4.jpg";